module.exports = __webpack_public_path__ + "static/menu-18-mar-2021-low-3b8ac80104ed8ff0d512e830f30f4be5.pdf";